import { defaultConfig } from '../default.js';
import type { MultiMeterBarChartConsumerConfig } from '../types/multi-meter-bar-chart-config.js';

// TODO duplication - use type guards?
export const deserializeConfig = (
  serializedConfig: string,
): MultiMeterBarChartConsumerConfig => {
  try {
    return JSON.parse(serializedConfig);
  } catch {
    return defaultConfig;
  }
};
